export default __webpack_public_path__ + "static/media/erp-icon.65a1d620.svg";